import { useState } from 'react';
import {
  Box,
  Container,
  Tabs,
  Tab,
  Paper,
  Typography,
  Chip,
  Alert,
  IconButton,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  CalendarMonth as CalendarIcon,
  Description as FilesIcon,
  Assessment as ReportsIcon,
  Psychology as IntelligenceIcon,
} from '@mui/icons-material';
import ProjectsDashboard from './ProjectsDashboard';
import WeeklySchedule from './WeeklySchedule';
import ProjectDetail from './ProjectDetail';
import ProjectReports from './ProjectReports';
import PredictiveReports from './PredictiveReports';
import { mockProjects } from './mockData';

export default function ProjectManagement() {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showDemoInfo, setShowDemoInfo] = useState(true);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleProjectSelect = (project) => {
    setSelectedProject(project);
    setActiveTab(3); // Switch to project detail tab
  };

  const handleBackToDashboard = () => {
    setSelectedProject(null);
    setActiveTab(0);
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
      {/* Demo Info Banner */}
      {showDemoInfo && (
        <Alert
          severity="info"
          sx={{ mb: 2 }}
          action={
            <IconButton
              size="small"
              onClick={() => setShowDemoInfo(false)}
            >
              ×
            </IconButton>
          }
        >
          <Typography variant="body2">
            <strong>PM Demo Mode:</strong> This is a demonstration of project management features integrated with your inventory system.
            All data shown is sample data for demonstration purposes.
          </Typography>
        </Alert>
      )}

      <Paper elevation={3}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab
              icon={<DashboardIcon />}
              label="Projects Dashboard"
              iconPosition="start"
            />
            <Tab
              icon={<CalendarIcon />}
              label="Weekly Schedule"
              iconPosition="start"
            />
            <Tab
              icon={<ReportsIcon />}
              label="Reports"
              iconPosition="start"
            />
            {/* Temporarily commented out - Intelligence tab
            <Tab
              icon={<IntelligenceIcon />}
              label="Intelligence"
              iconPosition="start"
            />
            */}
            {selectedProject && (
              <Tab
                icon={<FilesIcon />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {selectedProject.jobNumber}
                    <Chip
                      label={selectedProject.pm}
                      size="small"
                      sx={{
                        bgcolor: selectedProject.pmColor,
                        color: 'white',
                        height: 20
                      }}
                    />
                  </Box>
                }
                iconPosition="start"
              />
            )}
          </Tabs>
        </Box>

        <Box sx={{ p: 3, minHeight: '600px' }}>
          {activeTab === 0 && (
            <ProjectsDashboard
              projects={mockProjects}
              onProjectSelect={handleProjectSelect}
            />
          )}

          {activeTab === 1 && (
            <WeeklySchedule />
          )}

          {activeTab === 2 && (
            <ProjectReports />
          )}

          {/* Temporarily commented out - Intelligence tab
          {activeTab === 3 && (
            <PredictiveReports />
          )}
          */}

          {activeTab === 3 && selectedProject && (
            <ProjectDetail
              project={selectedProject}
              onBack={handleBackToDashboard}
            />
          )}
        </Box>
      </Paper>
    </Container>
  );
}